import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.subscription-error', {
        url: '/subscription_error',
        component: 'subscriptionError',
        resolve: {},
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/subscription-error/subscription-error.state.js